const FOUNDATION_RULES = {
    0: {
        1: {
            HL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 64.7, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading', weight: 17.65, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 17.65, defaultMaxMark: 100 }
            ],
            MATHEMATICS: [
                { key: 'numbersOperationsRelationships', label: 'Numbers, Operations & Relationships', weight: 20, defaultMaxMark: 100 },
                { key: 'patterns', label: 'Patterns', weight: 20, defaultMaxMark: 100 },
                { key: 'spaceShape', label: 'Space & Shape', weight: 20, defaultMaxMark: 100 },
                { key: 'measurement', label: 'Measurement', weight: 20, defaultMaxMark: 100 },
                { key: 'dataHandling', label: 'Data Handling', weight: 20, defaultMaxMark: 100 }
            ],
            LIFE_SKILLS: [
                { key: 'beginningKnowledgePsw', label: 'Beginning Knowledge & PSW', weight: 33, defaultMaxMark: 100 },
                { key: 'creativeArts', label: 'Creative Arts', weight: 33, defaultMaxMark: 100 },
                { key: 'physicalEducation', label: 'Physical Education', weight: 34, defaultMaxMark: 100 }
            ]
        }
    },
    1: {
        1: {
            FAL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 60, defaultMaxMark: 100 },
                { key: 'readingPhonics', label: 'Reading & Phonics', weight: 40, defaultMaxMark: 100 }
            ],
            HL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 25, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 20, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 25, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 20, defaultMaxMark: 100 },
                { key: 'handwriting', label: 'Handwriting', weight: 10, defaultMaxMark: 100 }
            ],
            MATHEMATICS: [
                { key: 'numbersOperationsRelationships', label: 'Numbers, Operations & Relationships', weight: 65, defaultMaxMark: 100 },
                { key: 'patterns', label: 'Patterns', weight: 10, defaultMaxMark: 100 },
                { key: 'spaceShape', label: 'Space & Shape', weight: 11, defaultMaxMark: 100 },
                { key: 'measurement', label: 'Measurement', weight: 9, defaultMaxMark: 100 },
                { key: 'dataHandling', label: 'Data Handling', weight: 5, defaultMaxMark: 100 }
            ],
            LIFE_SKILLS: [
                { key: 'beginningKnowledgePsw', label: 'Beginning Knowledge & PSW', weight: 40, defaultMaxMark: 100 },
                { key: 'creativeArts', label: 'Creative Arts', weight: 30, defaultMaxMark: 100 },
                { key: 'physicalEducation', label: 'Physical Education', weight: 30, defaultMaxMark: 100 }
            ]
        }
    },
    2: {
        1: {
            FAL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 50, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 20, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 25, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 5, defaultMaxMark: 100 }
            ],
            HL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 20, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 20, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 25, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 25, defaultMaxMark: 100 },
                { key: 'handwriting', label: 'Handwriting', weight: 10, defaultMaxMark: 100 }
            ],
            MATHEMATICS: [
                { key: 'numbersOperationsRelationships', label: 'Numbers, Operations & Relationships', weight: 60, defaultMaxMark: 100 },
                { key: 'patterns', label: 'Patterns', weight: 10, defaultMaxMark: 100 },
                { key: 'spaceShape', label: 'Space & Shape', weight: 13, defaultMaxMark: 100 },
                { key: 'measurement', label: 'Measurement', weight: 12, defaultMaxMark: 100 },
                { key: 'dataHandling', label: 'Data Handling', weight: 5, defaultMaxMark: 100 }
            ],
            LIFE_SKILLS: [
                { key: 'beginningKnowledgePsw', label: 'Beginning Knowledge & PSW', weight: 40, defaultMaxMark: 100 },
                { key: 'creativeArts', label: 'Creative Arts', weight: 30, defaultMaxMark: 100 },
                { key: 'physicalEducation', label: 'Physical Education', weight: 30, defaultMaxMark: 100 }
            ]
        }
    },
    3: {
        1: {
            FAL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 40, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 30, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 20, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 10, defaultMaxMark: 100 }
            ],
            HL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 15, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 20, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 25, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 30, defaultMaxMark: 100 },
                { key: 'handwriting', label: 'Handwriting', weight: 10, defaultMaxMark: 100 }
            ],
            MATHEMATICS: [
                { key: 'numbersOperationsRelationships', label: 'Numbers, Operations & Relationships', weight: 58, defaultMaxMark: 100 },
                { key: 'patterns', label: 'Patterns', weight: 10, defaultMaxMark: 100 },
                { key: 'spaceShape', label: 'Space & Shape', weight: 13, defaultMaxMark: 100 },
                { key: 'measurement', label: 'Measurement', weight: 14, defaultMaxMark: 100 },
                { key: 'dataHandling', label: 'Data Handling', weight: 5, defaultMaxMark: 100 }
            ],
            LIFE_SKILLS: [
                { key: 'beginningKnowledgePsw', label: 'Beginning Knowledge & PSW', weight: 40, defaultMaxMark: 100 },
                { key: 'creativeArts', label: 'Creative Arts', weight: 30, defaultMaxMark: 100 },
                { key: 'physicalEducation', label: 'Physical Education', weight: 30, defaultMaxMark: 100 }
            ]
        },
        2: {
            FAL: [
                { key: 'listeningSpeaking', label: 'Listening & Speaking', weight: 40, defaultMaxMark: 100 },
                { key: 'phonics', label: 'Phonics', weight: 20, defaultMaxMark: 100 },
                { key: 'readingComprehension', label: 'Reading & Comprehension', weight: 30, defaultMaxMark: 100 },
                { key: 'writing', label: 'Writing', weight: 10, defaultMaxMark: 100 }
            ]
        }
    }
};

FOUNDATION_RULES[0][2] = FOUNDATION_RULES[0][1];
FOUNDATION_RULES[0][3] = FOUNDATION_RULES[0][1];
FOUNDATION_RULES[0][4] = FOUNDATION_RULES[0][1];

FOUNDATION_RULES[1][2] = FOUNDATION_RULES[1][1];
FOUNDATION_RULES[1][3] = FOUNDATION_RULES[1][1];
FOUNDATION_RULES[1][4] = FOUNDATION_RULES[1][1];

FOUNDATION_RULES[2][2] = FOUNDATION_RULES[2][1];
FOUNDATION_RULES[2][3] = FOUNDATION_RULES[2][1];
FOUNDATION_RULES[2][4] = FOUNDATION_RULES[2][1];

FOUNDATION_RULES[3][2].HL = FOUNDATION_RULES[3][1].HL;
FOUNDATION_RULES[3][2].MATHEMATICS = FOUNDATION_RULES[3][1].MATHEMATICS;
FOUNDATION_RULES[3][2].LIFE_SKILLS = FOUNDATION_RULES[3][1].LIFE_SKILLS;
FOUNDATION_RULES[3][3] = FOUNDATION_RULES[3][2];
FOUNDATION_RULES[3][4] = FOUNDATION_RULES[3][2];

const FOUNDATION_SUBJECT_NAMES = {
    FAL: 'First Additional Language',
    HL: 'Home Language',
    MATHEMATICS: 'Mathematics',
    LIFE_SKILLS: 'Life Skills'
};

const normalizeText = (value) => String(value || '').trim();
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const floorFoundationValue = (value, max = Number.POSITIVE_INFINITY) => {
    const safeValue = Number(value);
    if (!Number.isFinite(safeValue)) {
        return 0;
    }

    const bounded = Number.isFinite(max)
        ? clamp(safeValue, 0, max)
        : Math.max(safeValue, 0);
    return Math.floor(bounded + 1e-9);
};

function normalizeFoundationDefinition(definition) {
    if (!definition || !Array.isArray(definition.components)) {
        return null;
    }

    return {
        code: definition.code || definition.subjectCode || '',
        name: definition.name || definition.subjectName || '',
        mode: definition.mode || 'weighted',
        term: definition.term || 1,
        subjectCode: definition.subject_code || definition.subjectCode || '',
        components: definition.components.map((component) => ({
            key: component.key,
            label: component.label,
            reportScaleMax: Number(
                component.reportScaleMax ??
                component.report_scale_max ??
                component.defaultMaxMark ??
                component.default_max_mark ??
                100
            ) || 100,
            weight: Number(component.weight ?? 0) || 0,
            defaultMaxMark: Number(component.defaultMaxMark ?? component.default_max_mark ?? 0) || 0,
            sections: (component.sections || []).map((section) => ({
                label: section.label,
                maxScore: Number(section.maxScore ?? section.max_mark ?? 0) || 0
            }))
        }))
    };
}

function normalizeTerm(term) {
    const numericTerm = parseInt(term, 10);
    return [1, 2, 3, 4].includes(numericTerm) ? numericTerm : 1;
}

function buildFoundationDefinition(code, grade, term, subjectCode) {
    const rules = FOUNDATION_RULES[grade]?.[term]?.[subjectCode];
    if (!rules || rules.length === 0) {
        return null;
    }

    return {
        code,
        name: `${grade === 0 ? 'Grade R' : `Grade ${grade}`} ${FOUNDATION_SUBJECT_NAMES[subjectCode]}`,
        mode: 'weighted',
        term,
        subjectCode,
        components: rules.map((rule) => ({
            key: rule.key,
            label: rule.label,
            reportScaleMax: rule.defaultMaxMark,
            weight: rule.weight,
            defaultMaxMark: rule.defaultMaxMark,
            sections: [{ label: rule.label, maxScore: rule.defaultMaxMark }]
        }))
    };
}

export function calculateComponentMark(rawScore, maxScore, targetScale = 100) {
    const safeRaw = Number(rawScore);
    const safeMax = Number(maxScore);
    const safeScale = Number(targetScale);

    if (!Number.isFinite(safeRaw) || !Number.isFinite(safeMax) || !Number.isFinite(safeScale)) {
        throw new Error('calculateComponentMark received a non-numeric value.');
    }
    if (safeMax <= 0 || safeScale <= 0) return 0;

    return floorFoundationValue((clamp(safeRaw, 0, safeMax) / safeMax) * safeScale, safeScale);
}

export function getNationalRatingCode(percentage) {
    const rounded = Math.round(clamp(Number(percentage) || 0, 0, 100));
    if (rounded >= 80) return 7;
    if (rounded >= 70) return 6;
    if (rounded >= 60) return 5;
    if (rounded >= 50) return 4;
    if (rounded >= 40) return 3;
    if (rounded >= 30) return 2;
    return 1;
}

export function inferFoundationSubjectCode(subjectName, grade, gradingMode, foundationTemplateCode) {
    if (gradingMode === 'foundation' && foundationTemplateCode) {
        const match = /^G([0-3])_([A-Z_]+)$/i.exec(String(foundationTemplateCode).trim());
        if (match) {
            return String(foundationTemplateCode).trim().toUpperCase();
        }
    }

    const numericGrade = parseInt(grade, 10);
    if (![0, 1, 2, 3].includes(numericGrade)) {
        return null;
    }

    const normalized = normalizeText(subjectName).toLowerCase();

    if (
        numericGrade === 0 &&
        (
            normalized.includes('english') ||
            normalized.includes('afrikaans') ||
            normalized.includes('home language') ||
            normalized.includes('huistaal') ||
            /\bhl\b/.test(normalized)
        )
    ) {
        return 'G0_HL';
    }

    if (
        normalized.includes('first additional language') ||
        normalized.includes('additional language') ||
        normalized.includes('eerste addisionele taal') ||
        /\bfal\b/.test(normalized)
    ) {
        return `G${numericGrade}_FAL`;
    }

    if (
        normalized.includes('home language') ||
        normalized.includes('huistaal') ||
        /\bhl\b/.test(normalized)
    ) {
        return `G${numericGrade}_HL`;
    }

    if (
        normalized.includes('life skills') ||
        normalized.includes('lewensvaardigheid') ||
        normalized.includes('lewensvaardighede')
    ) {
        return `G${numericGrade}_LIFE_SKILLS`;
    }

    if (
        normalized.includes('mathematics') ||
        /\bmaths?\b/.test(normalized) ||
        normalized.includes('wiskunde')
    ) {
        return `G${numericGrade}_MATHEMATICS`;
    }

    return null;
}

export function getFoundationSubjectDefinition(subjectName, grade, gradingMode, foundationTemplateCode, term = 1, foundationTemplateDefinition = null) {
    const normalizedDefinition = normalizeFoundationDefinition(foundationTemplateDefinition);
    if (normalizedDefinition) {
        return normalizedDefinition;
    }

    const code = inferFoundationSubjectCode(subjectName, grade, gradingMode, foundationTemplateCode);
    if (!code) {
        return null;
    }

        const match = /^G([0-3])_([A-Z_]+)$/i.exec(code);
        if (!match) {
            return null;
        }

    const numericGrade = parseInt(match[1], 10);
    const subjectCode = match[2].toUpperCase();
    return buildFoundationDefinition(code, numericGrade, normalizeTerm(term), subjectCode);
}

export function calculateSubjectMark(subjectCode, components, options = {}) {
    const term = normalizeTerm(options.term);
    const definitionOverride = normalizeFoundationDefinition(options.definitionOverride);
    let definition = definitionOverride;

    if (!definition) {
        const match = /^G([0-3])_([A-Z_]+)$/i.exec(String(subjectCode || '').trim());
        if (!match) {
            throw new Error(`Unsupported Foundation Phase subject code: ${subjectCode}`);
        }

        definition = buildFoundationDefinition(
            String(subjectCode).trim().toUpperCase(),
            parseInt(match[1], 10),
            term,
            match[2].toUpperCase()
        );
    }

    if (!definition) {
        throw new Error(`Unsupported Foundation Phase subject code: ${subjectCode}`);
    }

    const maxOverrides = options.maxOverrides || {};
    const selectedComponentKeys = options.selectedComponentKeys || definition.components.map((component) => component.key);
    const selectedComponentSet = new Set(selectedComponentKeys);
    const componentResults = [];

    let totalAchieved = 0;
    let totalPossible = 0;

    definition.components.forEach((component) => {
        if (!selectedComponentSet.has(component.key)) {
            return;
        }

        const rawScore = Number(components[component.key] ?? 0);
        const rawMax = Number(
            maxOverrides[component.key] ??
            component.sections.reduce((sum, section) => sum + section.maxScore, 0)
        );

        if (rawMax <= 0) {
            return;
        }

        const percentage = (clamp(rawScore, 0, rawMax) / rawMax) * 100;
        const achieved = (percentage * component.weight) / 100;
        const reportScaleMax = Number(component.reportScaleMax || rawMax || 100) || 100;
        const convertedMark = calculateComponentMark(rawScore, rawMax, reportScaleMax);

        componentResults.push({
            key: component.key,
            label: component.label,
            rawScore: clamp(rawScore, 0, rawMax),
            rawMax,
            scaledMark: convertedMark,
            scaledMax: reportScaleMax,
            percentage: floorFoundationValue(percentage, 100),
            weight: component.weight,
            achieved,
            possible: component.weight
        });

        totalAchieved += achieved;
        totalPossible += component.weight;
    });

    if (totalPossible <= 0) {
        return {
            subjectCode: definition.code,
            subjectName: definition.name,
            mode: definition.mode,
            percentage: null,
            ratingCode: null,
            totalAchieved: 0,
            totalPossible: 0,
            components: []
        };
    }

    const percentage = floorFoundationValue((totalAchieved / totalPossible) * 100, 100);
    return {
        subjectCode: definition.code,
        subjectName: definition.name,
        mode: definition.mode,
        percentage,
        ratingCode: getNationalRatingCode(percentage),
        totalAchieved,
        totalPossible,
        components: componentResults
    };
}

export function buildSectionMarkLookup(sectionMarks) {
    const lookup = new Map();
    (sectionMarks || []).forEach((mark) => {
        lookup.set(`${mark.student_id}-${mark.section_id}`, mark);
    });
    return lookup;
}

export function calculateStandardSubjectResult(sections, markLookup, studentId) {
    let totalAchieved = 0;
    let totalPossible = 0;

    (sections || []).forEach((section) => {
        const markObj = markLookup.get(`${studentId}-${section.id}`);
        const mark = markObj && markObj.mark !== '' && markObj.mark != null
            ? parseFloat(markObj.mark)
            : null;
        const max = parseFloat(section.max_mark) || 100;

        if (mark !== null && !Number.isNaN(mark) && max > 0) {
            totalAchieved += mark;
            totalPossible += max;
        }
    });

    const percentage = totalPossible > 0 ? Math.round((totalAchieved / totalPossible) * 100) : null;
    return {
        isFoundation: false,
        percentage,
        ratingCode: percentage !== null ? getNationalRatingCode(percentage) : null,
        totalAchieved,
        totalPossible
    };
}

export function calculateFoundationSubjectResult(definition, sections, markLookup, studentId, term = 1) {
    const componentScores = {};
    const componentMaxOverrides = {};
    const selectedComponentKeys = [];
    const groupedSections = new Map();
    const componentsByLabel = new Map(
        definition.components.map((component) => [component.label.toLowerCase(), component])
    );

    (sections || []).forEach((section) => {
        const groupLabel = normalizeText(section.assessment_group || section.section_name).toLowerCase();
        const component = componentsByLabel.get(groupLabel);
        if (!component) {
            return;
        }

        if (!groupedSections.has(component.key)) {
            groupedSections.set(component.key, { component, sections: [] });
        }
        groupedSections.get(component.key).sections.push(section);
    });

    groupedSections.forEach(({ component, sections: componentSections }, componentKey) => {
        let rawScore = 0;
        let rawMax = 0;
        let hasAnyMark = false;

        componentSections.forEach((section) => {
            const max = parseFloat(section.max_mark) || 0;
            if (max <= 0) {
                return;
            }

            rawMax += max;
            const markObj = markLookup.get(`${studentId}-${section.id}`);
            if (markObj && markObj.mark !== '' && markObj.mark != null && !Number.isNaN(parseFloat(markObj.mark))) {
                hasAnyMark = true;
                rawScore += parseFloat(markObj.mark);
            }
        });

        if (!hasAnyMark || rawMax <= 0) {
            return;
        }

        selectedComponentKeys.push(componentKey);
        componentScores[component.key] = rawScore;
        componentMaxOverrides[component.key] = rawMax;
    });

    const presentComponentKeys = selectedComponentKeys.filter((key) => componentMaxOverrides[key] > 0);
    const result = calculateSubjectMark(definition.code, componentScores, {
        term,
        maxOverrides: componentMaxOverrides,
        selectedComponentKeys: presentComponentKeys,
        definitionOverride: definition
    });

    return {
        isFoundation: true,
        ...result
    };
}

export function calculateSubjectResult({
    subjectName,
    subjectGrade,
    gradingMode,
    foundationTemplateCode,
    foundationDefinition,
    term = 1,
    sections,
    markLookup,
    studentId
}) {
    const definition = getFoundationSubjectDefinition(
        subjectName,
        subjectGrade,
        gradingMode,
        foundationTemplateCode,
        term,
        foundationDefinition
    );
    if (!definition) {
        return calculateStandardSubjectResult(sections, markLookup, studentId);
    }
    return calculateFoundationSubjectResult(definition, sections, markLookup, studentId, term);
}

export function getFoundationGroupTarget(definition, groupLabel, groupRawMax = 0) {
    const component = definition.components.find(
        (entry) => entry.label.toLowerCase() === normalizeText(groupLabel).toLowerCase()
    );
    if (!component) {
        return groupRawMax;
    }
    return component.weight;
}

export function getFoundationOverallPossible(definition) {
    return definition.components.reduce((sum, component) => sum + component.weight, 0);
}

export function isFoundationManagedSubject(subjectName, grade, gradingMode, foundationTemplateCode, term = 1, foundationTemplateDefinition = null) {
    return !!getFoundationSubjectDefinition(subjectName, grade, gradingMode, foundationTemplateCode, term, foundationTemplateDefinition);
}
